export const DEFAULT_EXPORT_OPTIONS = {
  scope: 'batch',
  header: {
    farm: true,
    corral: true,
    batch: true,
    generatedAt: true,
    logo: true,
    connection: false,
  },
  analyses: {
    general: true,
    order: true,
    breed: true,
    bull: true,
  },
  matrixList: {
    enabled: true,
    filter: 'all',
    columns: {
      codVaca: true,
      diagnostico: true,
      ecc: true,
      touro: true,
      partida: false,
      ordemMatriz: false,
      racaMatriz: false,
      observacao: true,
      dataDg: false,
    },
  },
}

const cloneDefaults = () => JSON.parse(JSON.stringify(DEFAULT_EXPORT_OPTIONS))

export const normalizeExportOptions = (options = {}) => {
  const defaults = cloneDefaults()
  const normalized = {
    ...defaults,
    ...options,
    header: { ...defaults.header, ...(options.header || {}) },
    analyses: { ...defaults.analyses, ...(options.analyses || {}) },
    matrixList: {
      ...defaults.matrixList,
      ...(options.matrixList || {}),
      columns: {
        ...defaults.matrixList.columns,
        ...(options.matrixList?.columns || {}),
      },
    },
  }

  // The document must retain enough context to identify the batch.
  normalized.header.batch = true
  return normalized
}

export const validateExportOptions = (options) => {
  const normalized = normalizeExportOptions(options)
  const errors = []
  const selectedAnalyses = Object.values(normalized.analyses).filter(Boolean)

  if (selectedAnalyses.length === 0) {
    errors.push('Selecione pelo menos uma análise.')
  }

  if (
    normalized.matrixList.enabled &&
    !Object.values(normalized.matrixList.columns).some(Boolean)
  ) {
    errors.push('Selecione pelo menos uma coluna para a lista de matrizes.')
  }

  return { valid: errors.length === 0, errors, options: normalized }
}

export const filterRowsForExport = (rows = [], filter = 'all') => {
  if (filter === 'all') return rows
  return rows.filter((row) => {
    if (filter === 'discarded') return row.isDiscard
    if (filter === 'pending') return !row.isSaved
    if (filter === 'pregnant') return row.diagnosisType === 'pregnant'
    if (filter === 'empty') return row.diagnosisType === 'empty'
    return true
  })
}

export const getSelectedAnalysisKeys = (options) =>
  Object.entries(normalizeExportOptions(options).analyses)
    .filter(([, selected]) => selected)
    .map(([key]) => key)

export const EXPORT_FILTERS = [
  { value: 'all', label: 'Todas' },
  { value: 'pregnant', label: 'Prenhes' },
  { value: 'empty', label: 'Vazias' },
  { value: 'pending', label: 'Pendentes' },
  { value: 'discarded', label: 'Descartes' },
]

export const EXPORT_COLUMNS = [
  { key: 'codVaca', label: 'Matriz' },
  { key: 'diagnostico', label: 'Resultado' },
  { key: 'ecc', label: 'ECC' },
  { key: 'touro', label: 'Touro' },
  { key: 'partida', label: 'Partida' },
  { key: 'ordemMatriz', label: 'Ordem' },
  { key: 'racaMatriz', label: 'Raça' },
  { key: 'observacao', label: 'Observação' },
  { key: 'dataDg', label: 'Data DG' },
]
